import { render } from "./Products.vue?vue&type=template&id=bbf66332&scoped=true"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"

import "./Products.vue?vue&type=style&index=0&id=bbf66332&scoped=true&lang=scss"

import exportComponent from "C:\\projects\\balkan-app\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbf66332"]])

export default __exports__